module.exports = __webpack_public_path__ + "static/media/whastappOn.ea24845c.png";